import TpCreditMemoStatusChangeItem from '../../../Domain/CreditMemo/TpCreditMemoStatusChangeItem';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import AuthService from '../../../Services/authService';
import TpCreditMemoService from '../../../Services/CreditMemo/TpCreditMemoService';

export default class StatusChangeTpCreditMemoWindowDescription {
  static titleForEdit = 'Credit Memo Request Status Change';
  static itemType = TpCreditMemoStatusChangeItem;
  static serviceFunction = TpCreditMemoService.StatusChange;

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'StatusChangeAction',
          label: 'Status Change Action',
          className: 'col-12',
          type: InputTypesEnum.Select,
          selectvalues: (item) => StatusChangeTpCreditMemoWindowDescription.GetStatusChangeValues(item),
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
        {
          fieldName: 'Comment',
          label: 'Comment',
          className: 'col-12',
          type: InputTypesEnum.TextBox,
          validityChecker: StatusChangeTpCreditMemoWindowDescription.IsCommentRequired,
        },
      ],
    },
  ];

  static IsCommentRequired(e, item) {
    if (!item.StatusChangeAction || (['Approve'].includes(item.StatusChangeAction) && !item.IsInfoRequested)) {
      return '';
    }
    return ValidityHelper.forRequiredTextField(e);
  }

  static GetStatusChangeValues(item) {
    //The Submitter can Decline the Credit Memo at any time
    const currentUserId = AuthService.getInstance().GetLoggedInUser().userId;
    if (item.SubmittedBy === currentUserId && item.AssignedTo !== currentUserId) {
      return [
        { value: null, label: '' },
        { value: 'Decline', label: 'Decline Credit Memo' },
      ];
    }

    //The submitter cannot ask for more information as they are the origin point
    if (item.Status === 'Created') {
      return [
        { value: null, label: '' },
        { value: 'Approve', label: 'Approve Credit Memo' },
        { value: 'Decline', label: 'Decline Credit Memo' },
      ];
    }

    //Beyond Created status, the user that is AssignedTo can move the status workflow backwards by asking for more information
    return [
      { value: null, label: '' },
      { value: 'Approve', label: 'Approve Credit Memo' },
      { value: 'Decline', label: 'Decline Credit Memo' },
      { value: 'Request Information', label: 'Request More Information' },
    ];
  }
}
